export const UTILITY_TYPE = {
    FIXED: 0,
    PERCENTAGE: 1
}